/* AG Plans, staff pricing tool (/pages/admin-plans).
   Lists products in a collection (default "training-plans") with editable price
   + compare-at, saved via the ag-library Worker. Same password gate as the
   library admin (OTP shell proxy; typed password kept in memory only). */
(function () {
  "use strict";
  var CFG = window.AG_PLANS_ADMIN || {};
  var WORKER = (CFG.worker || "").replace(/\/+$/, "");
  var COLLECTION = CFG.collection || "training-plans";
  var PW = "";
  var root;

  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }
  function el(h) { var d = document.createElement("div"); d.innerHTML = h.trim(); return d.firstChild; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }

  // With the OTP shell, every ag-library call routes through the auth Worker's
  // /api/lib proxy (server-side password injection; browser sends the token,
  // not the password). Without the shell (legacy lock-screen), hit ag-library
  // directly with the typed password.
  function proxyOn() { return !!(window.AG_ADMIN && typeof window.AG_ADMIN.lib === "function"); }

  async function ping(pw) {
    if (proxyOn()) { var pr = await window.AG_ADMIN.lib("/admin/ping", { method: "POST", headers: { "content-type": "application/json" }, body: "{}" }); return pr.ok; }
    var r = await fetch(WORKER + "/admin/ping", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ password: pw }) });
    return r.ok;
  }
  async function listPlans() {
    if (proxyOn()) { var pr = await window.AG_ADMIN.lib("/admin/plans?collection=" + encodeURIComponent(COLLECTION)); return pr.ok ? pr.json() : { found: false, plans: [] }; }
    var r = await fetch(WORKER + "/admin/plans?password=" + encodeURIComponent(PW) + "&collection=" + encodeURIComponent(COLLECTION));
    return r.ok ? r.json() : { found: false, plans: [] };
  }
  async function postJson(route, payload) {
    var r;
    if (proxyOn()) {
      // Don't send the shared password to the proxy, the Worker injects it.
      var clean = Object.assign({}, payload || {}); delete clean.password;
      r = await window.AG_ADMIN.lib(route, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(clean) });
    } else {
      r = await fetch(WORKER + route, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(payload) });
    }
    var j = await r.json().catch(function () { return {}; });
    if (!r.ok || j.error) throw new Error(JSON.stringify(j.error || j));
    return j;
  }

  function lockScreen(msg) {
    root.innerHTML = "";
    var box = el('<div class="agla-card agla-lock"><h1>Plans pricing</h1><p class="agla-sub">Staff access</p>' +
      (msg ? '<p class="agla-err">' + esc(msg) + "</p>" : "") +
      '<input type="password" id="agpa-pw" placeholder="Admin password"><button class="agla-btn" id="agpa-enter">Enter</button></div>');
    root.appendChild(box);
    var input = box.querySelector("#agpa-pw");
    var go = async function () {
      var pw = input.value.trim(); if (!pw) return;
      if (await ping(pw)) { PW = pw; render(); }
      else lockScreen("Wrong password.");
    };
    box.querySelector("#agpa-enter").addEventListener("click", go);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") go(); });
    input.focus();
  }

  function row(p, subs) {
    var r = el('<div class="agpa-row">' +
      '<div class="agpa-meta"><strong>' + esc(p.title) + "</strong>" +
        (p.selling_plan ? '<span class="agpa-sp">↻ ' + esc(p.selling_plan) + "</span>" : '<span class="agpa-sp agpa-sp--one">one-time</span>') +
        '<span class="agpa-subs" title="Active subscribers">' + (subs || 0) + " sub" + ((subs || 0) === 1 ? "" : "s") + "</span>" +
        '<select class="p-status agpa-status-sel is-' + (p.status || "active").toLowerCase() + '" title="Storefront visibility: Live (card shows), Unlisted (off the catalogue, link still works), Draft (hidden)">' +
          '<option value="ACTIVE"' + (p.status === "ACTIVE" ? " selected" : "") + '>Live</option>' +
          '<option value="UNLISTED"' + (p.status === "UNLISTED" ? " selected" : "") + '>Unlisted</option>' +
          '<option value="DRAFT"' + (p.status === "DRAFT" ? " selected" : "") + '>Draft</option>' +
        '</select>' +
      "</div>" +
      '<label class="agpa-f">Price (£)<input type="number" step="0.01" min="0" class="p-price" value="' + esc(p.price || "") + '"></label>' +
      '<label class="agpa-f">Compare-at (£)<input type="number" step="0.01" min="0" class="p-compare" value="' + esc(p.compare_at || "") + '"></label>' +
      '<button class="agla-btn p-save">Save</button>' +
      '<span class="agpa-status"></span>' +
    "</div>");
    var st = r.querySelector(".agpa-status");
    var btn = r.querySelector(".p-save");
    btn.addEventListener("click", async function () {
      if (!p.variantId) { st.textContent = "No variant"; st.className = "agpa-status agpa-err"; return; }
      btn.disabled = true; st.textContent = "Saving…"; st.className = "agpa-status";
      try {
        await postJson("/admin/set-price", {
          password: PW, productId: p.productId, variantId: p.variantId,
          price: r.querySelector(".p-price").value, compare_at: r.querySelector(".p-compare").value,
        });
        st.textContent = "Saved ✓"; st.className = "agpa-status agpa-ok";
      } catch (e) { st.textContent = "Error"; st.className = "agpa-status agpa-err"; }
      btn.disabled = false;
      setTimeout(function () { st.textContent = ""; st.className = "agpa-status"; }, 2600);
    });
    var sel = r.querySelector(".p-status");
    sel.addEventListener("change", async function () {
      var status = sel.value, prev = p.status; sel.disabled = true;
      try {
        await postJson("/admin/product-status", { password: PW, productId: p.productId, status: status });
        p.status = status; sel.className = "p-status agpa-status-sel is-" + status.toLowerCase();
      } catch (e) { alert("Show/hide failed: " + (e && e.message || e)); sel.value = prev || "ACTIVE"; }
      sel.disabled = false;
    });
    return r;
  }

  async function listStats() {
    try { var r = proxyOn() ? await window.AG_ADMIN.lib("/admin/plan-stats") : await fetch(WORKER + "/admin/plan-stats?password=" + encodeURIComponent(PW)); return r.ok ? r.json() : null; }
    catch (e) { return null; }
  }

  async function render() {
    root.innerHTML = '<div class="agla-loading">Loading plans…</div>';
    var data;
    try { data = await listPlans(); }
    catch (e) { root.innerHTML = '<p class="agla-err">Couldn\'t load. Check the password / Worker.</p>'; return; }

    if (!data.found) {
      root.innerHTML = "";
      root.appendChild(el('<div class="agpa-empty"><h2>No “' + esc(COLLECTION) + '” collection found</h2>' +
        "<p>Create a collection with the handle <code>" + esc(COLLECTION) + "</code> and add your plan products (the subscription products) to it. " +
        "They’ll show up here for pricing.</p></div>"));
      return;
    }

    var plans = data.plans || [];
    var stats = await listStats();
    var subsByPlan = {};
    if (stats && stats.plans) stats.plans.forEach(function (s) { subsByPlan[String(s.plan)] = s.subscribers || 0; });
    var totalSubs = 0, totalMrr = 0;
    plans.forEach(function (p) { var n = subsByPlan[p.title] || 0; totalSubs += n; totalMrr += n * (parseFloat(p.price) || 0); });

    var wrap = el('<div class="agpa"></div>');
    wrap.appendChild(el('<div class="agpa-stats">' +
      '<div class="agpa-stat"><strong>' + totalSubs + '</strong><span>Active subscribers</span></div>' +
      '<div class="agpa-stat"><strong>£' + totalMrr.toFixed(2) + '</strong><span>MRR (subs &times; price)</span></div>' +
      "</div>"));
    wrap.appendChild(el('<div class="agpa-head"><h2>' + esc(data.collectionTitle || "Training Hall") + "</h2>" +
      '<p class="agla-hint">' + plans.length + " plan" + (plans.length === 1 ? "" : "s") + ". Set the price (recurring amount) and compare-at, choose visibility, and see live subscribers. Subscriber counts are members whose subscription is paid up, worked out from their renewal orders, with 23 days' grace if a payment fails.</p></div>"));
    if (!plans.length) {
      wrap.appendChild(el('<p class="agla-hint">No products in this collection yet. Add your plan subscription products to <code>' + esc(COLLECTION) + "</code>.</p>"));
    }
    plans.forEach(function (p) { wrap.appendChild(row(p, subsByPlan[p.title] || 0)); });
    root.innerHTML = ""; root.appendChild(wrap);
  }

  /* The lock screen keeps a typed password in memory only. It used to save it
     to localStorage (agLibAdminPwd), where it outlived the tab; any copy left
     by an older build is cleared on load. */
  function forgetLegacyPwd() { try { localStorage.removeItem("agLibAdminPwd"); } catch (e) {} }

  /* With the OTP shell the proxy authenticates by session token and ignores a
     typed password, so a failed probe means no access (or the proxy is
     unreachable). Say so, with a retry; never fall back to a password prompt. */
  function noAccess() {
    root.innerHTML = "";
    var box = el('<div class="agla-card agla-lock"><h1>Plans pricing</h1>' +
      '<p class="agla-err">Your account does not have access to plans pricing, or it could not be reached just now.</p>' +
      '<p class="agla-sub">Ask an admin for access if you need it.</p>' +
      '<button class="agla-btn" id="agpa-retry">Try again</button></div>');
    root.appendChild(box);
    box.querySelector("#agpa-retry").addEventListener("click", function () { window.location.reload(); });
  }

  ready(function () {
    root = document.getElementById("agpa-root");
    if (!root) return;
    forgetLegacyPwd();
    // With the OTP shell present, use the session's staff password, no prompt.
    if (window.AG_ADMIN && typeof window.AG_ADMIN.onReady === "function") {
      window.AG_ADMIN.onReady(function () {
        try { PW = (window.AG_ADMIN.pwd && window.AG_ADMIN.pwd()) || ""; } catch (e) {}
        // Probe the ag-library proxy with the OTP token; on success render, else
        // tell the user they have no access (no password fallback).
        ping().then(function (ok) { if (ok) render(); else noAccess(); }).catch(function () { noAccess(); });
      });
    } else {
      lockScreen("");
    }
  });
})();
